import * as React from 'react'

import { NoteTabs } from '@user/components/Notes/EntityNotes/NoteTabs'
import { ENTITY_TYPES } from '@sales-center/common'
import { ILeadDetail } from '@user/store/lead'
import { IOpportunityDetail } from '@user/store/opportunity'

import Box from '@mui/material/Box'

type Props = {
  entityType: ENTITY_TYPES
  detail: ILeadDetail | IOpportunityDetail
  canUpdate: boolean
}

export function Notes(props: Props) {
  return (
    <Box display="flex">
      <NoteTabs {...props} />
    </Box>
  )
}
